export default __webpack_public_path__ + "static/media/photo-1519345182560-3f2917c472ef.a2e6c02e.jpeg";